import BreadCrumbs from 'components/breadcrumbs'
import PMBPagination from 'components/PMBPagination'
import { TableComponent as DataTable } from 'components/TableComponent'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, CardText } from 'reactstrap'
import { setFetchOption, toggleModalApproval } from './eventApprovalSlice'
import { useNavigate } from 'react-router-dom'
import { URL_EVENT } from 'utils/pathUrl'
import { useFetchEventQuery } from './eventApprovalApiSlice'
import { formatDateOnlyPMB } from 'utils/formatDate'
import { useState } from 'react'
import { useDebounce } from 'helpers'
import { Can } from 'context/Acl'
import CustomButton from 'components/Buttons/CustomButton'
import ModalApprovalEvent from './ModalApproval'

const ListEventApproval = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { tag } = useSelector((s) => s.event)
  const [selectedRows, setSelectedRows] = useState([])
  const [toggledClearRows, setToggleClearRows] = useState(false)

  const res = useFetchEventQuery(
    {
      ...tag,
    },
    { skip: !tag },
  )

  const columns = [
    {
      name: <span>Tanggal</span>,
      grow: 2,
      // sortable: true,
      cell: (row) => (
        <div>
          {formatDateOnlyPMB(row?.startDate)}
          {row?.endDate ? `- ${formatDateOnlyPMB(row?.endDate)}` : <></>}
        </div>
      ),
    },
    {
      name: <span>Judul</span>,
      selector: (row) => row.title,
      grow: 2,
      // sortField: 'title',
      // sortable: true,
      cell: (row) => <div>{row?.title}</div>,
    },
    {
      name: <span>Tipe</span>,
      selector: (row) => row.eventTypeName,
      grow: 1,
      // sortField: 'eventTypeName',
      // sortable: true,
      cell: (row) => <div>{row?.eventTypeName}</div>,
    },
    {
      name: <span>Event Partner</span>,
      selector: (row) => row.partnerName,
      grow: 2,
      // sortField: 'partnerName',
      // sortable: true,
      cell: (row) => <div>{row?.partnerName}</div>,
    },
    {
      name: <span>Pemateri</span>,
      selector: (row) => row.performeByUser,
      grow: 2,
      // sortField: 'performeByUser',
      sortable: true,
      cell: (row) => <div>{row?.performeByUser}</div>,
    },
  ]

  const handleSort = (column, direction) => {
    dispatch(
      setFetchOption({
        sortby: column.sortField,
        sortdir: direction === 'asc' ? 'desc' : 'asc',
      }),
    )
  }

  const debouncedSearch = useDebounce((value) => {
    dispatch(
      setFetchOption({
        page: 0,
        search: value,
      }),
    )
  }, 600)

  const handleChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows)
  }

  const handleClearRows = () => {
    setToggleClearRows(!toggledClearRows)
    setSelectedRows([])
  }

  return (
    <div className="w-100 px-3 pb-3">
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs
          breadCrumbActive={`Event Perlu Dikonfirmasi`}
          breadCrumbParent={'Event'}
          breadCrumbParentOnClick={() => navigate(URL_EVENT)}
        />
      </div>

      <ModalApprovalEvent row={selectedRows} refetch={res?.refetch} />

      <Card className="border-0 shadow-sm">
        <CardBody>
          <DataTable
            columns={columns}
            data={res?.data?.items}
            progressPending={res?.isLoading || res?.status === 'pending'}
            responsive
            persistTableHead
            defaultSortFieldId={1}
            defaultSortAsc={false}
            sortServer
            onSort={handleSort}
            pagination
            paginationServer
            selectableRows
            onSelectedRowsChange={handleChange}
            clearSelectedRows={toggledClearRows}
            paginationComponent={(props) => (
              <PMBPagination
                rowCount={res?.data?.totalItems}
                currentPage={tag?.page}
                rowsPerPage={tag?.size ?? 10}
                setCurrentPage={(e) => {
                  dispatch(setFetchOption({ page: e }))
                }}
                setRowsPerPage={(e) => {
                  dispatch(setFetchOption({ size: e }))
                }}
                props={props}
                testId="event-approval-pagination"
              />
            )}
            subHeader={true}
            subHeaderComponent={
              <div className="mb-3 w-100">
                <div className="d-flex flex-column flex-md-row justify-content-between w-100 mb-2">
                  <CardText tag="h5">{`Event Perlu Dikonfirmasi`}</CardText>
                  {/* <Can I={MANAGE} this={BUSINESS_ATTENDANCE_DASHBOARD}> */}
                  <CustomButton
                    color="primary"
                    onClick={() => dispatch(toggleModalApproval())}
                    disabled={selectedRows?.length < 1}
                    testId="event-approval-confirm-button"
                  >
                    Konfirmasi Sekaligus
                  </CustomButton>
                  {/* </Can> */}
                </div>
              </div>
            }
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default ListEventApproval
